import React, { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { RateTicker } from "@/components/RateTicker";
import { Hero } from "@/components/Hero";
import { ShopByCategory } from "@/components/ShopByCategory";
import { TrustStrip } from "@/components/TrustStrip";
import { AdvertisementBanner } from "@/components/AdvertisementBanner";
import { TrendingHighlights } from "@/components/TrendingHighlights";
import { OccasionGrid } from "@/components/OccasionGrid";
import { NewArrivalsPromo } from "@/components/NewArrivalsPromo";
import { HowItWorks } from "@/components/HowItWorks";
import { EnquirySection } from "@/components/EnquirySection";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { OfferPopup } from "@/components/OfferPopup";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      // Wait a tick for sections to mount before scrolling.
      setTimeout(() => scrollToId(id), 100);
    }
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <div className="mt-20">
        <RateTicker />
      </div>
      <main>
        <Hero />
        <ShopByCategory />
        <TrustStrip />
        <AdvertisementBanner />
        <TrendingHighlights />
        <OccasionGrid />
        <NewArrivalsPromo />
        <HowItWorks />
        <EnquirySection />
      </main>
      <Footer />
      <WhatsAppFloat />
      <OfferPopup />
    </div>
  );
}

